export default "__VITE_ASSET__BkCqsUTH__"